export const EMPTY_BANK_LINE_DESCRIPTION = '-'

// Bank lines can be created without a description (e.g. Shine card refunds), in which case the API returns an empty string.
export const getBankLineDescription = (description: string): string =>
  description.trim() ? description : EMPTY_BANK_LINE_DESCRIPTION
